<template>
  <div class="main-content">
    <v-container>
      <div class="page-content">
        <div class="article" v-if="article">
          <div class="page-content-head">
            <template v-if="article.parent">
              <h1 class="title-page">{{ article.parent.transTitle}}</h1>
            </template>
            <template v-else>
              <h1 class="title-page">{{ article.transTitle}}</h1>
            </template>
            <div class="indicator-3">
              <span class="green"></span>
              <span class="red"></span>
              <span class="red-light"></span>
            </div>
          </div>
          <div class="page-content-body">
            <!--<v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>-->
            <div class="body">
              <h1 class="title-view" v-if="!article.hide_title && article.parent">{{ article.transTitle}}</h1>
              <div class="content" v-if="!article.hide_content" v-html="article.transContent"></div>
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
  import CMS from '@/model/cms'

  export default {
    components: {},
    data: () => ({
      article: null,
      breadcrumbs: [],
    }),
    watch: {
      // при изменениях маршрута запрашиваем данные снова
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        CMS.loadPageBySlug(this.$route.params.slug)
          .then(response => {
            this.breadcrumbs = [
              {
                text: 'Главная',
                disabled: false,
                href: '/'
              }
            ]
            this.article = response.data
            if (this.article) {
              if (this.article.parent) {
                var ParentBreadcrumb = {}
                ParentBreadcrumb.text = this.article.parent.transTitle
                ParentBreadcrumb.disabled = false
                ParentBreadcrumb.href = '/blog/' + this.article.parent.slug
                this.breadcrumbs.push(ParentBreadcrumb)
              }
              var breadcrumb = {}
              breadcrumb.text = this.article.transTitle
              breadcrumb.disabled = true
              this.breadcrumbs.push(breadcrumb)
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    mounted () {
      this.fetchData()
    },

  }
</script>
